import React from "react";
import "../styles/AdminLogout.css";

interface AdminLogoutProps {
  onLogout: () => void;
}

export const AdminLogout: React.FC<AdminLogoutProps> = ({ onLogout }) => {
  return (
    <button className="admin-logout" onClick={onLogout}>
      Изход
    </button>
  );
};
